import styled from 'styled-components';

export const GallerySection = styled.section`
  background: white;
  padding: 100px 0;

  @media (max-width: 768px) {
    padding: 80px 0;
  }

  @media (max-width: 480px) {
    padding: 60px 0;
  }
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 15px;
  }

  @media (max-width: 480px) {
    padding: 0 10px;
  }
`;

export const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 60px;
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  color: #1f2937;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.75rem;
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 1.2rem;
  color: #6b7280;
  max-width: 600px;
  margin: 0 auto;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const GalleryContainer = styled.div`
  .slick-slider {
    margin: 0 -10px;
  }

  .slick-slide {
    padding: 0 10px;
  }

  .slick-dots {
    bottom: -50px;

    li button:before {
      color: #2563eb;
      font-size: 12px;
    }

    li.slick-active button:before {
      color: #2563eb;
    }
  }

  .slick-prev,
  .slick-next {
    z-index: 1;
    
    &:before {
      color: #2563eb;
      font-size: 30px;
    }

    @media (max-width: 768px) {
      display: none !important;
    }
  }

  .slick-prev {
    left: -40px;
  }

  .slick-next {
    right: -40px;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  padding: 10px;
  height: 300px;
  overflow: hidden;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    height: 250px;
  }

  @media (max-width: 480px) {
    height: 200px;
  }
`;

export const GalleryImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  transition: transform 0.3s ease;
  display: block;

  ${ImageWrapper}:hover & {
    transform: scale(1.05);
  }
`;

export const VideoIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: none;
  background: #000;
`;

export const ImagePlaceholder = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #9ca3af;
  font-size: 0.9rem;
  text-align: center;
  z-index: 1;
`;

export const LoadingMessage = styled.p`
  color: #6b7280;
  font-size: 1.1rem;
  margin-top: 1rem;
`;

export const ErrorMessage = styled.p`
  color: #ef4444;
  font-size: 1.1rem;
  margin-top: 1rem;
`;

// Lightbox Modal Styles
export const LightboxOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  opacity: ${props => props.isOpen ? 1 : 0};
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  transition: opacity 0.3s ease, visibility 0.3s ease;
`;

export const LightboxContent = styled.div`
  position: relative;
  max-width: 95vw;
  max-height: 95vh;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scale(${props => props.isOpen ? 1 : 0.9});
  transition: transform 0.3s ease;
`;

export const LightboxImage = styled.img`
  max-width: 100%;
  max-height: 95vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
`;

export const LightboxVideo = styled.iframe`
  max-width: 95vw;
  max-height: 95vh;
  width: ${props => props.isLandscape ? '95vw' : 'auto'};
  height: ${props => props.isLandscape ? 'auto' : '95vh'};
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  border: none;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  background: #000;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  font-size: 2rem;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10000;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
    transform: rotate(90deg);
  }

  @media (max-width: 768px) {
    top: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
    font-size: 1.5rem;
  }
`;

export const LightboxNavButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  font-size: 2rem;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10000;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-50%) scale(1.1);
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    width: 45px;
    height: 45px;
    font-size: 1.5rem;
  }
`;

export const LightboxPrev = styled(LightboxNavButton)`
  left: 20px;

  @media (max-width: 768px) {
    left: 10px;
  }
`;

export const LightboxNext = styled(LightboxNavButton)`
  right: 20px;

  @media (max-width: 768px) {
    right: 10px;
  }
`;

export const LightboxCounter = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  background: rgba(0, 0, 0, 0.5);
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 1rem;

  @media (max-width: 768px) {
    bottom: 10px;
    font-size: 0.9rem;
    padding: 8px 16px;
  }
`;
